/**
 * Configure Amplify v6 from the runtime AWS config. Called once at app boot
 * (see `src/main.tsx`).
 */

import { Amplify } from "aws-amplify";

import { awsConfig } from "@/aws-config";

export const configureAmplify = (): void => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: awsConfig.userPoolId,
        userPoolClientId: awsConfig.userPoolClientId,
        loginWith: {
          email: true,
        },
      },
    },
  });
};
